import { Ionicons } from "@expo/vector-icons";
import { t } from "i18next";
import React from "react";
import { Controller } from "react-hook-form";
import { Text, TextInput, View } from "react-native";

interface InputProps {
  control?: any;
  name: string;
  label: string;
  value?: string;
  withCustomLabel?: string;
  handleChange?: (text: string) => void;
  type?: string;
  rules?: object;
  error?: boolean;
  placeholder?: string;
  optional?: boolean;
  isPassword?: boolean;
  blocked?: boolean;
}

export default function Input(props: InputProps) {
  return (
    <View>
      {props.optional === true ? (
        <View className="flex-row m-2">
          <Text numberOfLines={undefined} className="text-black text-sm">
            {props.label}
          </Text>
          <Text className="text-midgray text-sm italic">{` (${t(
            "common:placeholder.optional",
          )})`}</Text>
        </View>
      ) : (
        <View className="flex-row m-2">
          <Text numberOfLines={undefined} className="text-black text-sm">
            {props.label}
          </Text>
          {props.withCustomLabel && (
            <Text className="text-midgray text-sm italic">{` (${props.withCustomLabel})`}</Text>
          )}
        </View>
      )}
      <View>
        <Controller
          control={props.control}
          name={props.name}
          rules={props.rules}
          render={({
            field: { value, onChange, onBlur, ref },
            fieldState: { error },
          }) => (
            <>
              <TextInput
                ref={ref}
                className={`border border-solid rounded-xl w-80 h-14 py-6 px-4 text-black1 ${
                  error ? "border-red" : "border-midgray"
                }`}
                value={props.value ? props.value : value}
                onChangeText={(text) => {
                  const currentText = text || "";
                  let filteredText = currentText;
                  if (props.type === "number") {
                    filteredText = text.replace(/[^0-9]/g, "");
                  } else if (props.type === "text") {
                    filteredText = text.replace(/[^A-Za-z -]/g, "");
                  } else if (props.type === "alpha") {
                    filteredText = text.replace(/[^A-Za-z0-9 -]/g, "");
                  }
                  onChange(filteredText);
                  props.handleChange?.(filteredText);
                }}
                onBlur={onBlur}
                secureTextEntry={props.isPassword}
                placeholder={props.placeholder}
                placeholderTextColor="#BDBDBD"
              />
              <View style={{ height: 20, overflow: "hidden" }}>
                {error && (
                  <Text className="text-red text-xs pl-2">{error.message}</Text>
                )}
              </View>
            </>
          )}
          defaultValue={props.value || ""}
        />
      </View>
    </View>
  );
}
